import Head from "next/head";
import Link from "next/link";
import FeaturedPeople from "../../components/Lists/FeaturedPeople";
import Pagination from "../../components/Pagination/Xpagination";
import List from "../../components/Lists/ListPeople";
import { ENDPOINTS, TAGS } from "../../utils/api-endpoints";
import {
  getAllPostCount,
  genStaticPagePaths,
  getHomePageDataBySlug,
  getPosts,
} from "../../utils/GhostAPI";
import { redirectTo500 } from "../../utils/utility";
import { useRouter } from "next/router";

export const getStaticPaths = async () => {
  return getAllPostCount(TAGS.PEOPLE, "+featured:false").then((count) => {
    return {
      paths: genStaticPagePaths(count),
      fallback: true,
    };
  });
};

export async function getStaticProps(context) {
  const featuredConfig = {
    filter: "tag:" + TAGS.PEOPLE + "+featured:true",
    include: "date,excerpt",
    limit: "all",
  };
  const listPagedConfig = {
    filter: "tag:" + TAGS.PEOPLE + "+featured:false",
    include: "date,excerpt",
    page: context.params.page,
  };

  let pageData = await getHomePageDataBySlug(ENDPOINTS.PEOPLE);
  let featuredData = await getPosts(featuredConfig);
  let listPagedData = await getPosts(listPagedConfig);

  if (!pageData || !featuredData || !listPagedData) {
    return redirectTo500();
  }
  let pagination = listPagedData.meta.pagination;

  return {
    props: {
      pageData: pageData,
      postsData: {
        featured: featuredData,
        listPaged: listPagedData,
      },
      pagination: pagination,
    },
    revalidate: 3600,
  };
}

const People = (props) => {
  const router = useRouter();
  if (router.isFallback) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <Head>
        <title>People | Best Software Company in Bangladesh</title>
        <meta
          name="description"
          content="DSi maintains a diverse pool of talents boasting more than 150 highly skilled software engineers. Aside from developers and QA engineers, teams at DSi include project managers, technical writers, and support engineers."
        />
      </Head>

      <div className="w-full pt-6 md:pt-16">
        <div className="grid mid-home-column items-center">
          <h2 className="text-black font-headline break-words text-center font-normal text-4xl md:text-6xl">
            Meet The Innovators
          </h2>
        </div>
      </div>

      <div className="w-full pb-9 mt-9 md:mt-20 mb-4">
        <div className="grid mid-home-column ">
          <div className="pb-9 md:pb-12 items-center flex flex-col mx-5">
            <h2 className="text-black font-headline text-center break-words font-extrabold text-3xl md:text-4xl mb-1">
              Key Personnel
            </h2>
            <p className="flex font-headline text-center text-base md:text-xl leading-8 text-gray-600">
              Our distinguished leaders and revered mentors
            </p>
          </div>
          <div className="flex mx-5">
            <FeaturedPeople
              data={props.postsData.featured}
              path="/people/innovator/"
              title="VIEW DETAIL"
            />
          </div>
        </div>
      </div>
      <div id="pplgallary" className="w-full pb-12 md:pb-20">
        <div className="">
          <div className="pb-12 md:pb-16 items-center flex flex-col px-5">
            <h2 className="text-black font-headline break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
              270 Seasoned Engineers
            </h2>
            <p className="flex text-center font-headline text-base md:text-xl leading-8 text-gray-600">
              Our people are our strength
            </p>
          </div>

          <div className="flex flex-wrap">
            <List data={props.postsData.listPaged} path="/people/innovator/" />
          </div>
          <div className="px-0 mx-3">
            <Pagination
              currentIndex={props.pagination.page}
              totalPages={props.pagination.pages}
              nextPage={props.pagination.next}
              prevPage={props.pagination.prev}
              path="/people/"
              pageanchor="#pplgallary"
            />
          </div>
        </div>
      </div>
      <div className="w-full pb-12 md:pb-28">
        <div className="grid mid-home-column">
          <div className="pb-9 md:pb-12 items-center flex flex-col">
            <h2 className="text-black font-headline break-words text-center font-extrabold text-3xl md:text-4xl mb-1 md:mb-4">
              Join Us
            </h2>
            <p className="flex font-headline text-center text-base md:text-2xl text-gray-600">
              Take the chance of growing up with DSi
            </p>
            <Link href="https://app.hrythmic.com/recruit/openings/company/dsinnovators/">
              <a target="_blank">
                <p className="border border-black text-center inline-block bg-yellow-btn hover:bg-black hover:text-white font-button px-8 py-2 text-xs font-semibold mt-6 md:mt-12 mx-auto">
                  SEE ALL OPENINGS
                </p>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default People;
